// /src/hooks/useAuth.js
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { onAuthStateChanged, getIdTokenResult } from "firebase/auth";
import { auth, db } from "../firebase";
import { collection, query, where, getDocs, limit } from "firebase/firestore";

const AuthCtx = createContext({});

async function fetchProfileByEmail(email) {
  if (!email) return null;
  const qy = query(
    collection(db, "users"),
    where("email", "==", email.toLowerCase()),
    limit(1)
  );
  const snap = await getDocs(qy);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [claims, setClaims] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      try {
        setUser(u);
        setProfile(null);
        setClaims(null);
        if (u?.email) {
          const token = await getIdTokenResult(u).catch(() => null);
          setClaims(token?.claims || null);
          const p = await fetchProfileByEmail(u.email);
          setProfile(p);
        }
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  const isAdmin = !!(
    (claims && (claims.plan === "Admin" || claims.plan === "admin" || claims.admin === true)) ||
    (profile &&
      (String(profile.plan || "") === "Admin" ||
        String(profile.plan || "").toLowerCase() === "admin" ||
        profile.isAdmin === true ||
        String(profile.plan || "") === "Admin" ||
        String(profile.plan || "").toLowerCase() === "admin")) // your schema
  );

  const value = useMemo(
    () => ({ user, profile, claims, isAdmin, loading }),
    [user, profile, claims, isAdmin, loading]
  );
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
